import * as R from 'ramda';
import {isNotNil} from './TypescriptUtils';

/**
 * A transparent wrapper around R.pipe that's slightly less annoying to use in typescript
 * It allows you to directly specify the return (and arument) for the generated function,
 *   and does no type checking on the in-between functions.
 */
export const pipe = <TOut, TIn = unknown>(...fns: Function[]) =>
  R.pipe(
    // @ts-ignore
    ...fns
  ) as (x: TIn) => TOut;

/**
 * Takes an array of functions and passes the same payload to each.
 * It will stop and return the value of any method that returns
 * something that is not nil.
 */
export const applyUntilNonNil =
  <T>(fns: Array<(x: any) => T | null | undefined>) =>
  (value: any) => {
    // Iterate over functions and apply them to the value
    for (const fn of fns) {
      const result = fn(value);
      // Return the result if it is non-nil
      if (isNotNil(result)) {
        return result;
      }
    }
    // Return nil if no non-nil result is found
    return null;
  };
